import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logo from '../assets/images/logo.png'
import { faHome, faList, faMessage, faPowerOff, faUser } from '@fortawesome/free-solid-svg-icons';
import { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
const MainLayout = ({ children }) => {

    const [hide, setHide] = useState(false)

    const location = useLocation()

    useEffect(() => {
        if (location.pathname === '/') {
            setHide(true)
        }
    }, [location.pathname])

    const handleLogout = () => {
        localStorage.removeItem('token')
        setTimeout(() => {
            window.location.href = '/'
        }, 1000);
    }

    return (
        <div className="w-full h-screen flex flex-col justify-center items-center" style={{ background: "linear-gradient(to bottom,  rgb(74, 96, 159) 30%, rgb(250, 250, 250) 0%)" }}>
            <div className=' h-[90vh]  lg:w-[35%] w-[100%] lg:p-0 p-5'>
                <div className='mb-3'>
                    <img src={logo} className='w-24 lg:w-32 mb-4' alt='' />
                    {hide && <h3 className='text-xl lg:text-3xl font-bold text-white'>Welcome Atfik</h3>}
                </div>

                <div className={`${hide ? "h-[74vh] lg:h-[65vh]" : "h-[80vh] "}  overflow-auto bg-white rounded-lg shadow-md `}>
                    {children}
                </div>
            </div>
            <div className='flex justify-between mt-5 px-5 items-center w-full lg:w-[35%]'>
                <Link to="/">
                    <FontAwesomeIcon icon={faHome} className='text-gray-600 text-xl lg:text-2xl cursor-pointer' />
                </Link>
                <Link to={'/list'}>
                    <FontAwesomeIcon icon={faList} className='text-gray-600 text-xl lg:text-2xl cursor-pointer' />
                </Link>
                <Link to="/profile">
                    <FontAwesomeIcon icon={faUser} className='text-gray-600 text-xl lg:text-2xl cursor-pointer' />
                </Link>
                <Link to='/chat'>
                    <FontAwesomeIcon icon={faMessage} className='text-gray-600 text-xl lg:text-2xl cursor-pointer' />
                </Link>
                <FontAwesomeIcon icon={faPowerOff} className='text-gray-600 text-xl lg:text-2xl cursor-pointer' onClick={handleLogout} />
            </div>

        </div>
    );
}
export default MainLayout;